'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return Array.prototype.includes || implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/array-includes/polyfill.js
// module id = 255
// module chunks = 35783957827783 172322841747965